module.exports = __webpack_public_path__ + "img/md_flow03-s.a229cc26.png";